import { BasketItemOrigin } from '@epicuro-next/data/baskets-dto';
import { getMergedBasketItemSource } from '@epicuro-next/utilities';
import {
  BasketItem,
  BasketItemSourceInput,
  BasketUpdateItem,
} from 'graphql-api/baskets-api-interfaces';

export const basketItemToBasketUpdateItem = (
  source: BasketItemSourceInput,
  {
    basketItemId,
    basketItemOrigin,
    brandId,
    productId,
    orderType,
    requestedDeliveryDate,
    consignmentStartDate,
    consignmentEndDate,
    displayDateFrom,
    displayDateTo,
    requestedQuantity,
    inventoryId,
  }: BasketItem,
): BasketUpdateItem => {
  return {
    basketItemId,
    brandId,
    note: '',
    productId,
    orderType,
    requestedDeliveryDate,
    consignmentStartDate,
    consignmentEndDate,
    displayDateFrom,
    displayDateTo,
    requestedQuantity,
    inventoryId,
    ...getMergedBasketItemSource(
      source,
      {
        basketItemId,
      },
      basketItemOrigin as BasketItemOrigin,
    ),
  };
};

// we omit basketItemId, so GQL will create a new item
export const copyBasketItemToCreate = (
  source: BasketItemSourceInput,
  {
    basketItemId,
    basketItemOrigin,
    brandId,
    productId,
    orderType,
    requestedDeliveryDate,
    requestedQuantity,
    consignmentStartDate,
    consignmentEndDate,
    displayDateFrom,
    displayDateTo,
  }: BasketItem,
): BasketUpdateItem => ({
  brandId,
  note: '',
  productId,
  orderType,
  requestedQuantity,
  requestedDeliveryDate,
  displayDateFrom,
  displayDateTo,
  consignmentStartDate,
  consignmentEndDate,
  ...getMergedBasketItemSource(
    source,
    { basketItemId },
    basketItemOrigin as BasketItemOrigin,
  ),
});

export const basketItemToRemoveBasketUpdateItem = ({
  basketItemId,
  brandId,
  productId,
  orderType,
  requestedDeliveryDate,
  consignmentStartDate,
  consignmentEndDate,
  displayDateFrom,
  displayDateTo,
  inventoryId,
}: BasketItem): BasketUpdateItem => {
  return {
    basketItemId,
    brandId,
    note: '',
    productId,
    orderType,
    requestedDeliveryDate,
    consignmentStartDate,
    consignmentEndDate,
    displayDateFrom,
    displayDateTo,
    requestedQuantity: 0,
    inventoryId,
    source: {
      type: '',
    },
  };
};
